import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

import { Col, Row } from "reactstrap";
import { toast } from "react-toastify";

import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useGetLazyGetMockDrillDetailsById } from "apis/FireSafety/FireSafetyMockDrill/fireSafetyMockDrill";

import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";
import Backdrop from "Components/Common/Backdrop";
import Collapse from "../../../Components/Common/FireSafetyBuildingViewDetailComponent/Collapse";

import { DialogHeader } from "Components/ApplicationViewModal/style";

import getFileExtension from "utils/getFileExtension";
import { getImageUrl } from "utils";
import removeExtension from "utils/removeExtension";

import ViewMockScheduleData from "./ViewMockScheduleData";
import ViewMockDrillData from "./ViewMockDrillData";

import pdfImg from "assets/images/pdf.png";

const docFormats = ["doc", "docx"];

const MockDrillViewModal = ({
  moackDrillDetailId,
  handleClose,
  isExpandable = true,
  t,
}) => {
  const [documentToPreview, setDocumentToPreview] = useState(null);
  const [
    getMockDrillDetail,
    {
      data: { data: mockDrillData = [] } = {},
      isLoading: isMockDrillDataLoading,
    },
  ] = useGetLazyGetMockDrillDetailsById();

  useEffect(() => {
    try {
      if (moackDrillDetailId) {
        getMockDrillDetail(moackDrillDetailId);
      }
    } catch (error) {}
  }, [moackDrillDetailId]);

  const previewButtonHandler = (name, documentURL) => {
    const fileExtension = getFileExtension(name ?? "");
    const url = getImageUrl(documentURL ?? "");

    if (docFormats.includes(fileExtension?.toLowerCase())) {
      toast.success("Document downloaded successfully");
    } else {
      setDocumentToPreview({
        documentTypeName: "",
        url,
        documentType: fileExtension,
        documentName: removeExtension(name ?? ""),
      });
    }
  };

  if (isMockDrillDataLoading) {
    return <Backdrop open />;
  }

  return (
    <>
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          {...documentToPreview}
        />
      )}

      <Dialog
        open={!!moackDrillDetailId}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        scroll="paper"
      >
        <DialogHeader>
          {t("Mock Drill Details")}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogHeader>
        <DialogContent>
          <DialogContentText variant="subtitle2" component="div">
            {mockDrillData && (
              <ViewMockScheduleData mockDrillData={mockDrillData} />
            )}
            {mockDrillData && mockDrillData?.mockDrillDetail && (
              <ViewMockDrillData mockDrillData={mockDrillData} />
            )}
            {mockDrillData?.mockDrillDetail?.attachmentUrl && (
              <Collapse title="Mock Drill Document" isExpandable={isExpandable}>
                <Row className="d-flex gap-3 flex-wrap">
                  <Col lg={2} md={4} sm={6} xs={12} className="image-container">
                    <a
                      onClick={() =>
                        previewButtonHandler(
                          mockDrillData?.mockDrillDetail?.attachmentUrl,
                          mockDrillData?.mockDrillDetail?.attachmentUrl
                        )
                      }
                    >
                      <Box
                        component="img"
                        className="image d-block m-auto cursor-pointer"
                        alt="document image"
                        src={
                          getFileExtension(
                            (
                              mockDrillData?.mockDrillDetail?.attachmentUrl ??
                              ""
                            ).toLowerCase()
                          ) === "pdf"
                            ? pdfImg
                            : getImageUrl(
                                mockDrillData?.mockDrillDetail?.attachmentUrl
                              )
                        }
                      />
                    </a>
                  </Col>
                </Row>
              </Collapse>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

MockDrillViewModal.propTypes = {
  moackDrillDetailId: PropTypes.number,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(MockDrillViewModal);
